import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { CurrentUserService } from './feat-current-user/current-user.service';

function initialiseAuth(currentUserService: CurrentUserService) {
  return () => currentUserService.initialise();
}

export function provideRmaUser(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const initializerFn = initialiseAuth(inject(CurrentUserService));
      return initializerFn();
    }),
  ]);
}
